module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pagination-area"
  }, [_c('p', [_vm._v("Foram encontrad" + _vm._s(_vm.gender) + "s " + _vm._s(_vm.total) + " " + _vm._s(_vm.object)), _c('br'), _vm._v("Exibindo de " + _vm._s(((_vm.pageAtual - 1) * _vm.perPage) + 1) + " até " + _vm._s(((_vm.pageAtual - 1) * _vm.perPage) + _vm.perPageAtual))]), _c('nav', {
    attrs: {
      "aria-label": "Paginação"
    }
  }, [_c('pagination', {
    attrs: {
      "totalPage": _vm.totalPage,
      "customActiveBGColor": "#00607D",
      "prevText": "<",
      "nextText": ">",
      "currentPage": _vm.pageAtual
    },
    on: {
      "btnClick": _vm.goToFunction
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-249a01da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/Paginacao.vue
// module id = 467
// module chunks = 0